import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@portal/BaseComponents/Button/AntButton";
import { SkeletonInput } from "@portal/BaseComponents/Skeleton/AntSkeleton";
import {
  FileList,
  ItemRenderParams,
  UploadProps,
} from "@portal/BaseComponents/Upload/type";
import { Files } from "@portal/types/file";
import { sessionStore } from "@portal/util/browser-storage";
import { AcceptedFileTypes } from "@portal/util/file";
import { PreviewType, UploadedFiles } from "../UplodedFiles/UploadedFiles";
import { UploadDragger } from "./Dragger/UploadDragger";
import { StyledDocUpload } from "./style";

const t = {
  upload_files: "Upload File",
  desc: "Click or drop your files here",
  max_size: "Max file size: 20mb",
  title: {
    upload: "Upload File",
    uploaded: "Uploaded Files",
  },
};

const UploadIcon = (
  <FontAwesomeIcon icon={["fal", "arrow-to-top"]} color="var(--primary-7)" />
);

export const acceptInputAttr = AcceptedFileTypes.join();
export interface DefaultFileUploaderProps<Files> {
  fileList?: FileList<Files>;
  onRemove?: NonNullable<UploadProps<Files>["onRemove"]>;
  hide?: boolean;
  action?: UploadProps<Files>["action"];
  acceptInputAttr?: UploadProps<Files>["accept"];
  onPreview?: NonNullable<UploadProps<Files>["onPreview"]>;
  onChange?: NonNullable<UploadProps<Files>["onChange"]>;
  name?: string;
  beforeUpload?: NonNullable<UploadProps<Files>["beforeUpload"]>;
  mode?: "Button" | "Dragger";
  itemRender?: NonNullable<UploadProps<Files>["itemRender"]>;
  previewType: PreviewType;
}
function DocUploader(props: DefaultFileUploaderProps<Files>) {
  const { mode = "Button", previewType } = props;
  const id = sessionStore.getItem("customer_id") as string;

  const headers = {
    "GFIN-PORTAL-CUSTOMER-ID": id,
  };
  const defaultProps: UploadProps<Files> = {
    name: props.name,
    multiple: true,
    action: props.action,
    accept: props.acceptInputAttr ?? acceptInputAttr,
    onChange: props.onChange,
    fileList: props.fileList,
    onRemove: props.onRemove,
    onPreview: props.onPreview,
    beforeUpload: props.beforeUpload,
    itemRender: props.itemRender,
    listType: "text",
    headers: id ? headers : undefined,
  };

  function DefaultItemRender(...args: ItemRenderParams<Files>) {
    const [, file] = args;
    return file.response ? (
      <UploadedFiles
        fileObject={file.originFileObj}
        file={file.response}
        onRemove={args[3].remove}
        previewType={previewType}
      />
    ) : (
      <SkeletonInput active style={{ width: "160px" }} />
    );
  }
  if (mode === "Button") {
    return (
      <StyledDocUpload
        {...(defaultProps as any)}
        itemRender={props.itemRender ? props.itemRender : DefaultItemRender}
      >
        <Button icon={UploadIcon} actionButton>
          {t.title.upload}
        </Button>
      </StyledDocUpload>
    );
  }
  return <UploadDragger previewType={previewType} />;
}

export { DocUploader };
